// extracted by mini-css-extract-plugin
export default {"helpBoxWrapper":"lpHtxB","closeButton":"Ez6Qhh"};